import React, { useRef } from 'react';
import { FiSave } from 'react-icons/fi';

import Header from '../../components/header';

import api from '../../services/api';

function NewSuggestion({ history, match, location }) {
    const titleInput = useRef(null);
    const detailsInput = useRef(null);

    const { app } = location.state || {
        app: {
            _id: match.params.appId,
        },
    };

    async function createSuggestion() {
        const title = titleInput.current.value;
        const details = detailsInput.current.value;
        const newSuggestion = {
            title,
            application: app._id,
        };
        if (details.length > 0) {
            newSuggestion.details = [ details ];
        }
        await api.post(`/v0/apps/${app._id}/suggestions`, newSuggestion);
        history.push({
            pathname: `/apps/${app._id}/suggestions`,
            state: { app },
        });
    }

    return (
        <>
            <Header
                left={{
                    pathname: `/apps/${app._id}/suggestions`,
                    state: { app },
                }}
                right={<button className="icon-link" onClick={createSuggestion}><FiSave /></button>}
            />
            <main className="main-content">
                <h2>Nova Sugestão - {app.name}</h2>
                <div className="input-group">
                    <input type="text" placeholder="Título" ref={titleInput} />
                </div>
                <div className="input-group">
                    <textarea placeholder="Detalhes" ref={detailsInput}></textarea>
                </div>
            </main>
        </>
    );
}

export default NewSuggestion;